module.exports = __webpack_public_path__ + "img/meme-plans.a8cb06ac.jpg";